import {messageForCode} from "./error-codes";
import type {ErrorCode} from "../generated/openapi-contract";

const externalCommandMessages: Partial<Record<ErrorCode, string>> = {
    external_command_rejected: "Площадка отклонила команду по заявке. Обработка заблокирована. Обратитесь к администратору: нужно проверить заявку в кабинете площадки.",
    external_confirmation_failed: "Площадка не подтвердила результат команды. Обратитесь к администратору: нужно проверить статус заявки перед повторением.",
    external_receipt_confirmation_ambiguous: "Не удалось надёжно подтвердить загрузку чека на площадке. Обратитесь к администратору: нужно проверить чек и статус заявки на площадке.",
    external_account_unconfigured: "Кабинет площадки не настроен. Обратитесь к администратору: нужно настроить подключение площадки.",
    external_order_closed_at_source: "Площадка уже завершила или отменила заявку. Обратитесь к администратору для сверки состояния заявки.",
    external_automation_blocked: "Обработка заявки остановлена из-за инцидента. Обратитесь к администратору: нужно проверить заявку и причину блокировки.",
    external_writes_disabled: "Отправка команд на площадку отключена. Обратитесь к администратору: нужно проверить состояние заявки.",
};

/** Translate only recognized external-command codes; never expose raw bodies. */
export function externalCommandErrorMessage(err: unknown): string | null {
    return messageForCode(err, externalCommandMessages) ?? null;
}
